import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuildingViewComponent } from './building-view/building-view.component';
import { RouterModule } from '@angular/router';
import { NgPipesModule } from 'ngx-pipes';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [BuildingViewComponent],
  imports: [
    CommonModule, RouterModule,
    SharedModule,
    NgPipesModule,
    TabsModule.forRoot(),
  ],
  exports: [ BuildingViewComponent]
})
export class BuildingModule { }
